import { CoreBox, CoreDatepicker } from '@vitvio/design-system';
import { CoreClock } from '@vitvio/time-components';
import { useMissionControlCalendarContext } from './context/MissionControlCalendarContext';

export function MissionControlHeader() {
  const { selectedDate, setSelectedDate } = useMissionControlCalendarContext();

  return (
    <CoreBox flexRow justifyContent="space-between" alignItems="center" fullW px="2">
      <CoreDatepicker value={selectedDate} onChange={setSelectedDate} />
      <CoreClock showTimezone font="headings.L_SemiBold" timezoneFont="body.XS_SemiBold" />
    </CoreBox>
  );
}
